import {
  ADDNEWVOUCHERMAPPING_SUCCESS,
  ADDNEWVOUCHERMAPPING_FAILED,
  RESET_ADDNEWVOUCHERMAPPING,
  LOADING_ADDNEWVOUCHERMAPPING,
  NETWORK_ERROR_ADDNEWVOUCHERMAPPING,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADDNEWVOUCHERMAPPING:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case ADDNEWVOUCHERMAPPING_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case ADDNEWVOUCHERMAPPING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_ADDNEWVOUCHERMAPPING:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_ADDNEWVOUCHERMAPPING:
      return (state = initialState);
    default:
      return state;
  }
};
